<div class="center-all p-16">
  <div class="flex flex-col items-center">
    <ng-lottie
      width="300px"
      [options]="options"
      containerClass="moving-box another-class"
    />
    <h1 class="text-2xl md:text-3xl font-bold mb-2">Congratulations</h1>
    <p>Your profile is now complete</p>
    <button (click)="close()" class="btn-base text-white bg-primary mt-8 px-16 gap-3 hover:gap-4 center-all animate-all">Search Partner
      <i class="fa fa-arrow-right ml-2"></i>
    </button>
  </div>
</div>
